import * as z from "zod";

const groupRevenueStatsSchema = z.object({
  revenuePerCustomer: z.number(),
  totalRevenue: z.number(),
  revenuePer1kCustomers: z.number(),
  customerCount: z.number(),
});

export const getMarketingAgentSplitTestRevenueStats = {
  name: "getMarketingAgentSplitTestRevenueStats" as const,
  input: z.object({
    teamId: z.string(),
    splitId: z.string(),
    days: z.number(),
  }),
  output: z
    .object({
      variant: groupRevenueStatsSchema,
      control: groupRevenueStatsSchema,
    })
    .nullable(),
};
